import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled.div``;

export const Thead = styled.thead``;

export const Tr = styled.tr``;

export const Tbody = styled.tbody``;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

type LastProp = {
  isLast?: boolean;
  underAnalysis?: boolean;
};

export const TableHeader = styled.th<LastProp>`
  background-color: #fafafa;
  padding: 12px 16px;
  border-bottom: 1px solid #cbcbcb;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    width: ${({ isLast }) => (isLast ? '66%' : '33%')};
    font-size: 12px;
    line-height: 18px;
  }
`;

export const TableRow = styled.tr`
  background: #ffffff;
  border-color: #cbcbcb;
`;

export const TableData = styled.td<LastProp>`
  padding: 12px 16px;
  border-bottom: 1px solid #cbcbcb;
  text-align: left;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #636363;

  @media (max-width: 768px) {
    width: ${({ isLast }) => (isLast ? '66%' : '33%')};
    font-size: 12px;
    line-height: 18px;
  }
`;

export const Button = styled.button`
  padding: 6px 14px;
  border: 1px solid #0b29fb;
  border-radius: 5px;
  background: transparent;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #0b29fb;
`;

export const ModalDetailComponent = styled(Modal)`
  &.modal {
    transform: translateX(10%);
  }

  & .modal-dialog {
    max-width: calc(100vw - 250px);
    max-height: 100vh;
    padding: 35px;
    margin: 0;
  }

  & .modal-content {
    & > div {
      height: calc(100vh - 70px);
      overflow: hidden;

      @media (max-width: 768px) {
        overflow: auto;
      }
    }

    @media (max-width: 768px) {
      padding-bottom: 12px;
    }
  }

  @media (max-width: 768px) {
    &.modal {
      transform: unset;
    }

    & .modal-dialog {
      max-width: 100vw;
      padding: 8px;
    }

    & .modal-content {
      & > div {
        width: 100%;
      }
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ButtonMobile = styled.button`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 5px;
  background: transparent;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
